import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-r from-[#ededed] to-[#dcdcdc]">
      <Outlet />
    </div>
  );
};

export default AuthLayout;
